<template>
  <el-dialog
    class="statistic-export"
    title="导出"
    :visible.sync="isShowStatisticExportDialog"
    :close-on-click-modal="false"
    width="40%"
  >
    <div class="content">
      <div class="item-wrap" v-if="teamCheckList.length">
        <div class="head-box">
          <div class="title-text">团队/组</div>
          <div class="dotted-line"></div>
          <div class="select-all">
            <el-checkbox v-model="teamSelectAll" @change="handleTeamSelectAll">全选</el-checkbox>
          </div>
        </div>
        <div class="team-list-box">
          <div class="check-item" v-for="(item, index) in teamCheckList" :key="index">
            <el-checkbox v-model="item.isActive">{{item.label}}</el-checkbox>
          </div>
        </div>
      </div>
      <div class="item-wrap" v-if="userCheckList.length">
        <div class="head-box">
          <div class="title-text">用户</div>
          <div class="dotted-line"></div>
          <div class="select-all">
            <el-checkbox v-model="userSelectAll" @change="handleUserSelectAll">全选</el-checkbox>
          </div>
        </div>
        <div class="team-list-box">
          <div class="check-item" v-for="(item, index) in userCheckList" :key="index">
            <el-checkbox v-model="item.isActive">{{item.label}}</el-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <div class="btn confirm-btn" @click="confirm">确定</div>
    </div>
  </el-dialog>
</template>

<script>
  import gql from 'graphql-tag';
  import api from '../api';
  export default {
    
    data() {
      return {
        timeDate:{},
        typeValue:'',
        imageType:'',
        isShowStatisticExportDialog: false,
        teamSelectAll: false,
        // 团队/组选项列表
        teamCheckList: [],
        userSelectAll: false,
        userCheckList: [],
        role: -1,
      };
    },
    
    watch: {
      teamCheckList: {
        handler(newVal) {
          if (newVal.length) {
            const filterArr = newVal.filter(item => item.isActive);
            this.teamSelectAll = filterArr.length === newVal.length;
          }
        },
        deep: true,
      },
      userCheckList: {
        handler(newVal) {
          if (newVal.length) {
            const filterArr = newVal.filter(item => item.isActive);
            this.userSelectAll = filterArr.length === newVal.length;
          }
        },
        deep: true,
      },
    },
    
    methods: {
      // 显示弹框 初始化数据
      showStatisticExportDialog(teamGroupList, doctorList, role,timeDate,typeValue,imageTypeValue) {
       this.timeDate = timeDate.newTime;
       this.typeValue = typeValue;
       this.imageType = imageTypeValue;
       this.role = role;
       this.teamCheckList = [];
       for (const item of teamGroupList) {
          this.teamCheckList.push({
            id: item.id,
            label: item.label,
            isActive: false,
            team_name: item.team_name ? item.team_name : '',
          })
        }
        this.userCheckList = [];
        for (const item of doctorList) {
          this.userCheckList.push({
            id: item.id,
            label: item.label,
            isActive: false,
          })
        }
        this.isShowStatisticExportDialog = true;
      },
      async confirm() {
        const team_ids = [];
        const group_ids= [];
        const doctor_ids = [];
        if (this.role === 1) { // 团队负责人
          if (this.teamCheckList[0].isActive) {
            team_ids.push({
              team_id: this.teamCheckList[0].id,
              team_name: this.teamCheckList[0].team_name,
            })
          }
          const arr = this.teamCheckList.slice(1);
          for (const item of arr) {
            if (item.isActive) {
              group_ids.push({
                group_id: item.id,
                group_name: item.label,
              })
            }
          }
          for (const item of this.userCheckList) {
            if (item.isActive) {
              doctor_ids.push({
                doctor_id: item.id,
                doctor_name: item.label,
              })
            }
          }
        } else if (this.role === 2) {
          for (const item of this.teamCheckList) {
            if (item.isActive) {
              group_ids.push({
                group_id: item.id,
                group_name: item.label,
              })
            }
          }
          for (const item of this.userCheckList) {
            if (item.isActive) {
              doctor_ids.push({
                doctor_id: item.id,
                doctor_name: item.label,
              })
            }
          }
        } else if (this.role === 3) {
          for (const item of this.userCheckList) {
            if (item.isActive) {
              doctor_ids.push({
                doctor_id: item.id,
                doctor_name: item.label,
              })
            }
          }
        }
        if (team_ids.length || group_ids.length || doctor_ids.length) {
          const url = await this.statisticsExport(team_ids, group_ids, doctor_ids,this.timeDate.day_start,this.timeDate.day_end,this.typeValue,this.imageType);
          if (url) {
            window.open(api.server + url);
          }
          this.isShowStatisticExportDialog = false;
        }
      },
      async statisticsExport(team_ids, group_ids, doctor_ids,day_start,day_end,type, image_type) {
        console.log(day_start,day_end,type, image_type)
        try {
          const res = await this.$apollo.query({
            query: gql`query(
              $type: Int!
              $image_type: Int!
              $day_start: String!
              $day_end: String!
              $team_ids: [TeamInput]
              $group_ids: [GroupInput]
              $doctor_ids: [DoctorInput]
            ){
              statisticsExport(
                type: $type
                image_type: $image_type
                day_start: $day_start
                day_end: $day_end
                team_ids: $team_ids
                group_ids: $group_ids
                doctor_ids: $doctor_ids
              )
            }`,
            fetchPolicy: "no-cache",
            variables: {
              type,
              image_type,
              day_start,
              day_end,
              team_ids,
              group_ids,
              doctor_ids,
            },
          });
          return res.data.statisticsExport;
        } catch (error) {
          console.log(error)
          this.$message.error(error.message.split(":")[1]);
        }
      },
      handleTeamSelectAll(isSelectAll) {
        for (const item of this.teamCheckList) {
          item.isActive = isSelectAll;
        }
      },
      handleUserSelectAll(isSelectAll) {
        for (const item of this.userCheckList) {
          item.isActive = isSelectAll;
        }
      },
    },
    
  }
</script>

<style>
  /*dialog样式修改*/
  .statistic-export .el-dialog__header .el-dialog__title{
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .statistic-export .el-dialog__header{
    padding: 20px 24px 10px;
  }
  .statistic-export .el-dialog__body {
    padding: 0 20px;
  }
  .statistic-export .el-dialog__close{
    color: #4da3c0;
    font-size: 26px;
    font-weight: bold;
  }
  /*复选框样式修改*/
  .statistic-export .el-checkbox__label{
    color: rgb(124,124,124);
    font-size: 16px;
    font-weight: bold;
  }
  .statistic-export .select-all .el-checkbox__label{
    color: #4da3c0;
  }
  .statistic-export .el-checkbox__inner{
    width: 20px;
    height: 20px;
  }
  .statistic-export .el-checkbox__inner::after{
    width: 6px;
    height: 11px;
    top: 0;
    left: 6px;
  }
  .statistic-export .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #4da3c0;
    border-color: #4da3c0;
  }
  .statistic-export .el-checkbox__input.is-checked+.el-checkbox__label{
    color: rgb(124,124,124);
  }
  .statistic-export .select-all .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #4da3c0;
  }
  .statistic-export .el-checkbox__input.is-focus .el-checkbox__inner{
    border-color: #4da3c0;
  }
</style>
<style lang="less" scoped>
  .content{
    border-top: 2px solid #4da3c0;
    padding: 20px 15px 0;
    .item-wrap{
      margin-bottom: 10px;
      .head-box{
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        .title-text{
          color: #4da3c0;
          margin-right: 20px;
          font-size: 16px;
          font-weight: bold;
        }
        .dotted-line{
          flex: 1;
          height: 0;
          border-bottom: 2px dotted #4da3c0;
        }
        .select-all{
          margin-left: 20px;
        }
      }
      .team-list-box{
        display: flex;
        flex-wrap: wrap;
        padding: 0 10px;
        .check-item{
          width: 26%;
          margin-right: 11%;
          margin-bottom: 10px;
        }
        .check-item:nth-child(3n){
          margin-right: 0;
        }
      }
    }
  }
  .dialog-footer{
    display: flex;
    justify-content: flex-end;
    .confirm-btn{
      width: 120px;
      height: 18px;
      font-size: 14px;
    }
  }
</style>
